module.exports = __webpack_public_path__ + "img/xrpl-on-ious.5031bba1.png";